// 接口
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'
// 机器人列表
export const getRank = (data) => axios.get(baseUrl + '/queapi/aqi/rank?' + data)
// 创建机器人
export const getLxyWzData = () => axios.get(baseUrl + '/queapi/news/zysthjbhdc/all')

